import type { ExploreContentItemContentOneOfBasicInfoAllOf } from './exploreContentItemContentOneOfBasicInfoAllOf';
import type { ExploreContentItemContentOneOfBasicInfoAllOfTwo } from './exploreContentItemContentOneOfBasicInfoAllOfTwo';

export type ExploreContentItemContentOneOfBasicInfo = ExploreContentItemContentOneOfBasicInfoAllOf & ExploreContentItemContentOneOfBasicInfoAllOfTwo;
